import React, { Component, useEffect, useState, useRef } from "react";
import { RUN_TIME_API_ENDPOINT, GetCurrentUserRoles } from "../common/common";

import Modal from "react-responsive-modal";

const BusinessTargetsImport = (props) => {
  const inputImgElement = useRef(null);

  const [fileExtError, setFileExtError] = useState(false);
  const [sizeError, setSizeError] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const roleData = GetCurrentUserRoles();
    if (["$csa", "$ca"].indexOf(roleData[0]) === -1) {
      window.location.replace(window.location.origin + "/#/business_targets");
    }
  }, []);

  const handleImageChange = (e) => {
    e.preventDefault();
    const selectedFile = inputImgElement?.files;
    const fileExtention =
      selectedFile &&
      selectedFile[0].name.substring(
        selectedFile[0]?.name?.lastIndexOf(".") + 1
      );
    console.log("fileExtention", fileExtention, selectedFile[0]);

    const maxSize = 10;

    if (selectedFile[0].size / 1024 / 1024 > maxSize) {
      setFileExtError(false);
      setSizeError(true);
      // this.setState({
      //     fileExtError: false,
      //     sizeError: true,
      // });
    } else if ("csv" !== fileExtention) {
      setSizeError(false);
      setFileExtError(true);
      // this.setState({
      //     sizeError: false,
      //     fileExtError: true,
      // });
    } else {
      setSelectedFile(e.target.files[0]);
      setSizeError(false);
      setFileExtError(false);
      // this.setState({
      //     selectedFile: e.target.files[0],
      //     sizeError: false,
      //     fileExtError: false,
      // });
    }
  };

  const onSave = () => {
    setShowLoader(true);
    // this.setState({
    //     showLoader: true,
    // });
    const formData = new FormData();

    // Update the formData object
    formData.append("files", selectedFile);
    formData.append("file_name", selectedFile?.name);

    const stateData = localStorage.getItem("__state");
    const userData = stateData ? JSON.parse(stateData) : false;
    const options = {};
    options.method = "POST";
    options.headers = {
      Authorization: userData._token,
    };
    options.body = formData;

    const url = `${RUN_TIME_API_ENDPOINT}/business_targets`;
    fetch(url, options)
      .then((res) => {
        if (res.status === 401) {
          // localStorage.removeItem("__state");
          // window.location.href = "#/login";
        }
        return res.json();
      })
      .then((json) => {
        console.log("json==>", json);
        const msg = json.data[0].message;
        setShowModal(true);
        setMessage(msg);
        setShowLoader(false);
        // this.setState({
        //     showModal: true,
        //     message: msg,
        //     showLoader: false
        // });
        console.log("error json ===>", json);
        // window.location.reload();
      })
      .catch((error) => {
        setShowModal(true);
        setMessage("Something went wrong. Please try again.");
        setShowLoader(false);
        // this.setState({
        //     showModal: true,
        //     showLoader: false,
        //     message: 'Something went wrong. Please try again.'
        // })
        console.log("eroror", error);
      });
  };
  const onModalClose = () => {
    setShowModal(false);
    // this.setState({
    //     showModal: false,
    // });
    window.location.replace(window.location.origin + "/#/business_targets");
  };

  return (
    <React.Fragment>
      <div className="target-upload-container">
        <label>Upload File</label>
        <input
          type="file"
          accept=".csv"
          name="flies[]"
          ref={(inputFileImg) => {
            inputImgElement = inputFileImg;
          }}
          onChange={handleImageChange}
        />
        {(fileExtError || sizeError) && (
          <div className="valid-file-upload-error">
            {fileExtError && <p>File type must be .csv</p>}
            {sizeError && <p>File size must be less than 10 MB</p>}
          </div>
        )}
        <div className="valid-file-upload">
          <p>Instructions :</p>
          <ul>
            <li>Only CSV files are allowed with Comma as separator.</li>
            <li>File size should be less than 2 MB.</li>
            <li>
              Please wait for the file upload to complete and for the
              confirmation message to appear before moving away from this page.
            </li>
            <li>
              You will receive the results of the upload via email indicating
              how many records were added, updated and failed (if any).
            </li>
          </ul>
        </div>
        <div className="upload-file-format-download">
          <p>
            To get upload file format.{" "}
            <a
              href="https://clickit-static-files-prod.s3.eu-west-1.amazonaws.com/fille_formats/targets_upload.csv"
              target="_blank"
            >
              Click here
            </a>{" "}
            to download
          </p>
        </div>
        {showLoader && <div className="login-loader" />}
        {!showLoader && (
          <div className="so-save-button">
            <button onClick={onSave} disabled={!selectedFile}>
              Save
            </button>
          </div>
        )}
        {showModal && (
          <Modal open={showModal} onClose={onModalClose} center>
            <h3>{message}</h3>
          </Modal>
        )}
      </div>
    </React.Fragment>
  );
};

export default BusinessTargetsImport;
